import React from "react";

const Header = () => {
    return ( <h1 style={{color: '#eee'}}>My Task-List</h1> );
}
 
export default Header;